import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { CommonBindingDataService } from '../../services/common-binding-data.service';

import { AppSettings } from '../../../shared/app.settings';
import { StorageService } from './../../services/storage.service';
import { UiService } from './../../services/ui.service';
import { UserCommonService } from './../../services/user-common.service';
import { ErrorBindingService } from '../../services/error-binding.service';
import { Router } from '@angular/router';


@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    standalone: false
})
export class EditProfileComponent implements OnInit {

  @Input() editProfilePopup: boolean;
  @Output() showProfilePopup: EventEmitter<any> = new EventEmitter();
  profileUrl = AppSettings.DEFAULT_PROFILE_IMAGE_URL;
  uploadedImgId = '';

  fileUploadUrl: string = AppSettings.UPLOAD_FILE_URL;
  chooseLabel;
  editProfileForm: UntypedFormGroup;
  submitted: boolean;
  constructor(
    private formBuilder: UntypedFormBuilder,
    private storageService: StorageService,
    private commonServices: UserCommonService,
    private uiSerice: UiService,
    private commonBindingDataService: CommonBindingDataService,
    private errorBindingService: ErrorBindingService,
    private router: Router
  ) {
    this.commonBindingDataService.setTitle(this.commonBindingDataService.getLabel('label_header_profile'));
    this.setData();
  }

  ngOnInit() {
  }

  setFocus() {
    setTimeout(() => {
      document.getElementById('app-file-uploader').getElementsByTagName('input')[0].focus()
    }, 100)
  }

  setData() {
    this.chooseLabel = this.commonBindingDataService.getLabel('label_choose');
    const userObj: any = this.storageService.getItem(AppSettings.USER_DETAILS);
    let firstname = '';
    let lastname = '';
    let email = '';
    let phone = '';
    let phoneCode = '+1';

    if (userObj !== undefined && userObj !== null) {
      firstname = userObj.firstName;
      lastname = userObj.lastName;
      email = userObj.email;
      phone = userObj.phoneNum;
      phoneCode = userObj.numCountryCode;
      if (userObj.userDetails !== undefined && userObj.userDetails !== null && userObj.userDetails.profileImage !== null) {
        this.profileUrl = AppSettings.GET_FILE_THUMB_URL + userObj.userDetails.profileImage;
      }
    }

    this.editProfileForm = this.formBuilder.group({
      firstName: [firstname, [Validators.required, Validators.maxLength(30)]],
      lastName: [lastname, [Validators.required, Validators.maxLength(30)]],
      email: [email, [Validators.required, Validators.email]],
      phoneCode: [phoneCode, [Validators.required, Validators.pattern(AppSettings.NUMBER_PATTERN)]],
      phone: [phone, [Validators.required, Validators.pattern(AppSettings.PHONE_PATTERN),
      Validators.minLength(7), Validators.maxLength(15)]]
    });
  }

  closeEditProfile() {
    this.showProfilePopup.emit(false);
  }

  onUploadProfileImage(response) {
    this.profileUrl = AppSettings.GET_FILE_THUMB_URL + response.fileId;
    this.uploadedImgId = response.fileId;
    this.remove()
  }

  remove() {
    if (document.getElementsByClassName('ui-fileupload-content').length > 0) {
      document.getElementsByClassName('ui-fileupload-content')[0].setAttribute('id', 'remove');
      document.getElementById('remove').remove();
    }
  }

  updateProfile() {
    this.submitted = true;
    if (this.editProfileForm.valid) {
      const userObj: any = this.storageService.getItem(AppSettings.USER_DETAILS);
      const userId = userObj.id;
      const editProfileData = {
        firstName: this.editProfileForm.controls.firstName.value,
        lastName: this.editProfileForm.controls.lastName.value,
        email: this.editProfileForm.controls.email.value,
        phoneNum: this.editProfileForm.controls.phone.value,
        profileImage: this.uploadedImgId,
        numCountryCode: this.editProfileForm.controls.phoneCode.value,
      };

      this.commonServices.updateUserProfile(editProfileData, userId).subscribe(results => {
        if (results.userModel !== null && results.userModel !== undefined) {
          this.storageService.setItem(AppSettings.USER_DETAILS, results.userModel);
          this.errorBindingService.setMessage({ severity: 'success', summary: 'Success', detail: 'Profile is updated Successfully' });
          setTimeout(() => {
            this.showProfilePopup.emit(false);
            this.uiSerice.profileUpdated();
          }, 1000);
        }
      }, (error) => {

        this.errorBindingService.setMessage({ severity: 'success', summary: 'Success', detail: error.general[0].message });
      });
    } else {
      this.errorBindingService.getFormValidationErrors(this.editProfileForm);
    }
  }
    redirectToAppReleaseHistory() {
    this.router.navigate(['/app-release-history']);
  }
}
